import { cn } from '@april9au/react-common/utils';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

import { SectionHeader } from './section-header';

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

/** Expandable Q&A list. Reusable on the homepage, service pages, or a dedicated FAQ page. */
export function FaqSection({
  id,
  eyebrow,
  heading,
  description,
  faqs,
  className,
}: {
  id?: string;
  eyebrow?: string;
  heading: string;
  description?: string;
  faqs: Array<FaqItem>;
  className?: string;
}) {
  return (
    <section id={id} className={cn('section', className)}>
      {/* max-w-[720px] on the accordion itself, not on `.container` — capping
          the outer container (the old `container--narrow`) re-centres a
          narrower box inside the page's already-padded 1200px column, so the
          questions end up indented ~240px further right than every heading
          and hero above them on the same page. Capping just this element
          keeps the comfortable reading width without moving its left edge
          off the column every other section on the page aligns to. */}
      <div className="container">
        <SectionHeader
          eyebrow={eyebrow}
          heading={heading}
          description={description}
          align="left"
          className="mb-12"
        />

        <Accordion type="single" collapsible className="flex w-full max-w-[720px] flex-col gap-y-4">
          {faqs.map((faq) => (
            <AccordionItem key={faq.id} value={faq.id}>
              <AccordionTrigger>{faq.question}</AccordionTrigger>
              <AccordionContent>{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
